export default __webpack_public_path__ + "static/media/aboutMe-img_myimg.c60c756a.png";